module.exports = __webpack_public_path__ + "47fd8d67bbde73f7a41e707682b07fac.svg";